import React from 'react'

import { MdEmail } from 'react-icons/md'

import { P } from '../../../style/Typography.style'

import CopyToClipboard from '../../CopyToClipboard'

// import WorkExperienceCard from '../../dashboard/TalentPool/WorkExperienceCard'
import TechnicalSkillCard from '../../dashboard/TalentPool/TechnicalSkillCard'
import CharRefCard from '../../dashboard/TalentPool/CharacterRefCard'

import peopleImage from "../../../assets/image/manual_cv_wallpaper.png"; 
import styled from "styled-components";

const ManualCV = ({
  name = 'Applicant Name',
  professionalHeadline = 'No Professional Headlines Yet',
  ooklaLink = 'No Speed Test Result Yet',
  email = 'No Email',
  phoneNumber = 'No Phone Number',
  professionalSummary = '',
  workExperience = [],
  backupInfrastructure,
  technicalSkills = [],
  characterReferences = [],
  profesionalHeadlines='',
  education,
}) => {
  return (
    <>
    <HeroContainer>
      <HeaderWrapper>
        <LogoRow>
          <img src={require('../../../assets/image/ho_logo.png')} alt="HOPLA Online" />
        </LogoRow>

        <Title>HOPLA <br/> Candidate <br/> Profile</Title>
        {/* <SubTitle>Marketing Assistant</SubTitle> */}

        {/* <TeamImage src={teamImg} alt="Team" /> */}
      </HeaderWrapper>
    </HeroContainer>
    
    {/* Personal Profile */}
    <HeaderContainer>
      <Left>
        <Name>{name}</Name>   
        <Role>{professionalHeadline}</Role>
        <EmailRow>
          <MdEmail size="1.2rem" />
          <span>{email}</span>
          <CopyToClipboard text={email} />
        </EmailRow>
      </Left>
      <VerticalLine />
      <Right>
        <SummaryTitle>EXECUTIVE SUMMARY</SummaryTitle>
         <P
          marginBottom="0.5rem"
          dangerouslySetInnerHTML={{
            __html: (professionalSummary) || "Summary not provided",
          }}
        />
      </Right>
    </HeaderContainer>
    {/* End of Personal Details */}
    
    {/* Professional Details */}
    <P textTransform="uppercase" style={{ color: '#1A196B', marginTop: '2rem', fontWeight: 400, fontSize: '.875rem' }}>
      PROFESSIONAL SUMMARY
    </P>
    <hr style={{ border: 0, borderTop: '2px solid #0e0d0dff', margin: '0.5rem 0' }} />
    
    <WorkExperience>
      {workExperience && workExperience.length > 0 ? (
        workExperience.map(
          (
            {
              companyName,
              jobTitle,
              jobDescriptionHtml,
              experienceFrom,
              experienceTo,
              companyLocation,
            },
            index
          ) => (
            <JobEntry key={index}>

              <JobLeft>
                <div>
                    {companyName} ({new Date(experienceFrom).getFullYear()} - {new Date(experienceTo).getFullYear()})
                </div>
                <div className="job-title">{jobTitle}</div>
              </JobLeft>

              <JobRight>
                <div className="location">{companyLocation}</div>
                <div
                  dangerouslySetInnerHTML={{ __html: jobDescriptionHtml }}
                />
              </JobRight>
            </JobEntry>
          )
        )
      ) : (
        <P>No work experiences.</P>
      )}
    </WorkExperience>
    
    {/* End of Professional Details */}
    
    {/* Education Details */}
    <P textTransform="uppercase" style={{ color: '#1A196B', marginTop: '2rem', fontWeight: 500, fontSize: '.875rem' }} >
      EDUCATION
    </P>
    <hr style={{ border: 0, borderTop: '2px solid #0e0d0dff', margin: '0.5rem 0' }} />

    {education && education.length > 0 ? (
      <ul>
        {education?.map((edu, idx) => (
          <li key={idx}>{edu}</li>
        ))}
      </ul>
    ) : (
      <P>No educational details.</P>
    )}
    {/* End of Educational Details */}

    {/* Technical Skills */}
    <P textTransform="uppercase" style={{ color: '#1A196B', marginTop: '2rem', fontWeight: 500, fontSize: '.875rem' }}>
      Skills & proficiencies
    </P>
    <hr style={{ border: 0, borderTop: '2px solid #1b1919ff', margin: '0.5rem 0' }} />

    <SkillsGrid>
      {technicalSkills &&
        technicalSkills.slice(0, 9).map(({ skill, experience, id }) => (
          <TechnicalSkillCard key={id} skill={skill} experience={experience} />
        ))}
    </SkillsGrid>

      {ooklaLink && (
        <P
          color="red"
          weight="500"
          marginTop="0.4rem"
          marginBottom="0.6rem"
          size=".875rem"
        >
          {ooklaLink}
        </P>
      )}
      
      {characterReferences && characterReferences.length > 0 ? (
        characterReferences.map(({ id, crName, crEmail, crPhone }, index) => (
          <CharRefCard
            key={id}
            crName={crName}
            crEmail={crEmail}
            crPhone={crPhone}
          />
        ))
      ) : (
        <P>No Character References.</P>
      )}
    </>
  )
}

export default ManualCV

const HeroContainer = styled.section`
  padding: 2rem 2rem;
  text-align: left;
  position: relative;
  background: url(${peopleImage}) no-repeat center bottom;
  background-size: cover;
  height: 500px;
`;

const HeaderWrapper = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    align-items: left;
    text-align: left;
    font
    padding: 1rem;
  }
`;

const LogoRow = styled.div`
  margin-bottom: 1rem;

  img {
    width: 220px;
    height: auto;

    @media (max-width: 768px) {
      width: 160px;
    }
  }
`;

const Title = styled.h1`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 700;
  font-size: 1.5rem;   /* default for laptops / mid screens */
  line-height: 1.2;
  color: #000;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 3.0rem;   /* tablets */
  }

  @media (max-width: 480px) {
    font-size: 2.3rem; /* phones */
  }

  @media (min-width: 1200px) {
    font-size: 2.5rem; /* large desktops */
  }

  @media (min-width: 1600px) {
    font-size: 3rem;   /* very large screens */
  }
`;

const SummaryTitle = styled.h3`
  font-size: 0.9rem;
  font-weight: 700;
  color: #e63946;
  text-transform: uppercase;
  margin: 0 0 0.5rem 0;
`;

// Personal Details
const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 5px;
  padding: 1rem 0;
  justify-content: center; /* Centers the flex container horizontally */
  width: 100%; /* Ensures it takes full width to center properly */
  margin: 0 auto; /* Centers the container if it has a defined width */
  max-width: 800px; /* Optional: Limits the maximum width for better readability */
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem; /* Tighter spacing */
  min-width: 250px;
  text-align: right;
  padding-left: 5px; /* Closer to vertical line */
`;

const Right = styled.div`
  flex: 1;
  min-width: 250px;
  margin-top: 8px; /* Closer to vertical line */
  padding-right: 5px; /* Reduced padding for closeness */
`;

const Name = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #1A196B;
  margin: 0;
`;

const Role = styled.div`
  font-size: 1rem;
  font-weight: 400;
  color: #e63946;
  text-transform: uppercase;
`;

const EmailRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #555;
  font-size: 0.9rem;
  justify-content: flex-end; /* Align email to the right */
`;

const VerticalLine = styled.div`
  width: 1px;
  background-color: #ccc;
  margin: 0 1.5rem;
`;

// Professional Summary 
const WorkExperience = styled.div`
  display: flex;
  flex-direction: column; /* stack jobs vertically */
  align-items: center;    /* center horizontally */
  justify-content: center; /* optional, for vertical centering */
  max-width: 800px;       /* para hindi sobrang lapad */
  margin: 0 auto;         /* center whole section in page */
`;

const JobEntry = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
`

const JobLeft = styled.div`
  flex: 1;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
  color: #D10158; /* dark blue for text */

  .job-title {
    margin-top: 0.25rem;
    font-weight: 500;
    color: #1A196B; /* dark blue for title */
    text-transform: uppercase;
  }
`

const JobRight = styled.div`
  flex: 2;
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;

  .location {
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
`

// For technical Skills Section
const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
  grid-template-rows: repeat(3, auto);  /* 3 rows */
  gap: 1rem; /* space between items */
  margin-top: 1rem;
`;